
export default {
  props: {
    colorProp: {
      type: String,
      default: "#7140FF"
    },
    size: {
      type: [Number, String],
      default: 24
    },
    image: {
      type: String,
      default: ""
    },
    username: {
      type: String,
      default: ""
    },
    rounded: {
      type: String,
      default: "rounded-circle"
    }
  }
};
